var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:this.class,attrs:{"id":this.id}},[_vm._v(_vm._s(this.rate))])
}
var staticRenderFns = []

export { render, staticRenderFns }